import {
  View,
  Text,
  StyleSheet,
  Platform,
  StatusBar,
  TouchableWithoutFeedback,
  Keyboard,
  SafeAreaView,
} from "react-native";
import React from "react";

export default function MyView(props) {
  return <View style={[style.main, props.style]}>{props.children}</View>;
}

const style = StyleSheet.create({
  main: {
    width: "100%",
    flex: 1,
    paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0,
  },
});
